import React, { Component } from "react";
import BlobUtil from '../../utils/blobUtil'

interface PropsFromState {

}

interface PropsFromDispatch {
  playerCurrentTime: any
  sourceVideo: any
  videoThumbnail: string
  startFrom?: number
  selectedImage: any
  showConcentrationAnswer: any
  popupImage: any
  allowToPlay: boolean
  checkAllowToPlay : boolean
  start: any
  played: any
  stopped: any
  completed: any
  rewind: { isRewind: boolean, duration: number }
  videoDuration : number
}
type AllProps = PropsFromState & PropsFromDispatch

interface IState {
}
export default class VideoPlayer extends Component<AllProps, IState> {
  videoRef?: HTMLVideoElement | undefined | null;
  myPlayer?: amp.Player;
  seeking: boolean = false;
  lastPlayTime: number = 0;
  maxPlayTime: number = 0;
  blobUtil: BlobUtil;

  selectedImageEventRegistered = false;
  popupContinueSelectedImageEventRegistered = false;
  concentrationQuestionAnswerEventRegistered = false;

  constructor(props: AllProps) {
    super(props);
    this.blobUtil = new BlobUtil();

    this.state = {
    }
  }

  async getVideoUrl(fileName:string) {
      let blobRequestUrl = await this.blobUtil.GetCoursesBlob(fileName, "courses");
      return blobRequestUrl;
  }

  GetImagePath(fileName: string){
    fileName = fileName.replace("/courses/","");
    return "https://images.ultimatespro.com/images/" + fileName;
  }
  async initPlayer() {

    let videoSrc = this.props.sourceVideo;
    //console.log("Video blob src (Before): " + videoSrc.src);
    videoSrc.src = await this.getVideoUrl(videoSrc.src);
    //console.log("Video blob src (After): " + videoSrc.src);

    this.myPlayer = amp(
      this.videoRef,
      {
        logo: { enabled: false },
        autoplay: false,
        fluid: true,
        plugins: this.getPlugins()
      },
      () => {
        console.log("Good to go!");
      }
    );

    //this.myPlayer.src([this.props.sourceVideo]);
    this.myPlayer.src([videoSrc]);
    this.myPlayer.poster(this.GetImagePath(this.props.videoThumbnail));

    this.myPlayer.addEventListener(amp.eventName.timeupdate, () => {
      if (this.myPlayer === undefined)
        return;

      if (this.seeking === true)
        return;

      // console.log("=> Start From : " + this.props.startFrom);
      // console.log("=> currentTime: " + this.myPlayer.currentTime());
      // console.log("=> lastPlayTime : " + this.lastPlayTime);

      if (this.myPlayer.currentTime() < Number(this.props.startFrom)) {
        this.lastPlayTime = this.myPlayer.currentTime();
        //console.log("stop Point 1");
        if (this.props.allowToPlay) {
          //const now = new Date();
          //console.log("timeupdate " + now.toTimeString()+ "; " + this.myPlayer.currentTime());
         
          //this.props.playerCurrentTime(this.lastPlayTime);
        } 
        //console.log("AAAA. ===> timeupdate " + this.lastPlayTime);

        this.props.playerCurrentTime(this.lastPlayTime); // Regardless allowToPlay to set current play time, else concentration will keep prompting
      }
      else {
        if (this.lastPlayTime < Number(this.props.startFrom)) {
          // console.log("BBBB. ===> lastPlayTime " + this.lastPlayTime);
          this.lastPlayTime = Number(this.props.startFrom);
        } else {

          if ((this.myPlayer.currentTime() - this.lastPlayTime) < 2) {
           // console.log("CCCCCC. ===> lastPlayTime " + this.lastPlayTime);
            this.lastPlayTime = this.myPlayer.currentTime();
            //console.log("stop Point 2");

            if (this.props.allowToPlay) {
              //const now = new Date();
              //console.log("timeupdate " + now.toTimeString() + "; " + this.myPlayer.currentTime());
              //console.log("DDDD. ===> timeupdate " + this.myPlayer.currentTime());

              this.props.playerCurrentTime(this.myPlayer.currentTime());
            }
            //this.props.playerCurrentTime(this.myPlayer.currentTime()); // Regardless allowToPlay to set current play time, else concentration will keep prompting
            //this.props.playerCurrentTime(this.lastPlayTime); 
          } else {
            //console.log("EEEEE. ===> lastPlayTime " + this.lastPlayTime);
            this.props.playerCurrentTime(this.lastPlayTime); 
          }
        }
      }

      if (this.lastPlayTime > this.maxPlayTime) {
        this.maxPlayTime = this.lastPlayTime;
      }



    });

    this.myPlayer.addEventListener(amp.eventName.seeking, () => {
      const now = new Date();
      //console.log("Seeking " + now.toTimeString());
      this.seeking = true;
    });

    this.myPlayer.addEventListener(amp.eventName.seeked, () => {
      const now = new Date();
      //console.log("Seeked " + now.toTimeString());
      this.seeking = false;
    });

    this.myPlayer.addEventListener(amp.eventName.play, () => {
      
      this.myPlayer.PopupContinueWatch.hideImage();

      const now = new Date();
      //console.log("==> Play " + now.toTimeString());
      if (this.myPlayer === undefined)
        return;

      //console.log("Last Play Time:" + this.lastPlayTime);
      //console.log(evt.type);
      let userLastPlaytime = this.lastPlayTime;
      if (Number(this.props.startFrom) > userLastPlaytime) {
        userLastPlaytime = Number(this.props.startFrom);
        //console.log("System Records Last Play Time:" + this.props.startFrom);
      }
      if (this.maxPlayTime > userLastPlaytime) {
        userLastPlaytime = this.maxPlayTime;
      }
      //console.log("Resume from :" + userLastPlaytime);

      //console.log("==> Video Play ");
      if (!this.props.allowToPlay) {
        //console.log("==> Not allow to play! ");
        if (this.props.checkAllowToPlay){
          //console.log("==> Not allow to play, stopped! ");
          this.myPlayer?.pause();
        }
      }
      else {
        //console.log("Last Play Time:" + this.lastPlayTime);
        //console.log(evt.type);
        let userLastPlaytime = this.lastPlayTime;
        if (Number(this.props.startFrom) > userLastPlaytime) {
          userLastPlaytime = Number(this.props.startFrom);
          //console.log("System Records Last Play Time:" + this.props.startFrom);
        }

        // If set this user can jump after answer wrong for concentration
        // if (this.maxPlayTime > userLastPlaytime) {
        //   userLastPlaytime = this.maxPlayTime;
        // }
        //console.log("Resume from :" + userLastPlaytime);

        //if (userLastPlaytime !== 0 && this.myPlayer.currentTime() > userLastPlaytime) {
        if (this.myPlayer.currentTime() > userLastPlaytime) {
          //console.log("@@@@@@@@@@@ Set Last Play Time to : "+ userLastPlaytime)
          this.lastPlayTime = userLastPlaytime;
          //this.pause();
          this.myPlayer.currentTime(userLastPlaytime);
          this.myPlayer.play();
        }

        this.props.played();
        //console.log(this.props.startFrom); // State not keep updating
      }

    });

    this.myPlayer.addEventListener(amp.eventName.pause, () => {
      //console.log("Video Pause");
      //this.myPlayer.PopupContinueWatch.loadImage("https://images.ultimatespro.com/images/general/play_250x250.png");
      this.myPlayer.PopupContinueWatch.showImage();

      this.props.stopped();
    });

    this.myPlayer.addEventListener(amp.eventName.loadeddata, () => {
      if (this.myPlayer === undefined)
        return;

      this.lastPlayTime = Number(this.props.startFrom);
      console.log("Set current time to startFrom " + this.lastPlayTime);
      this.myPlayer.currentTime(this.lastPlayTime);
    });

    this.myPlayer.addEventListener(amp.eventName.error, (evt: any) => {
      console.log("Video Player Error " + JSON.stringify(evt));
    });

    this.myPlayer.addEventListener(amp.eventName.playing, (evt: any) => {
      //console.log("Video Playing");
    });

    this.myPlayer.addEventListener(amp.eventName.complete, (evt: any) => {
      console.log("Video Play Complete");
      //this.props.completed();
    });
    this.myPlayer.addEventListener(amp.eventName.ended, (evt: any) => {
      console.log("Video Play Ended");
      //console.log("Video Play Ended, Current Time :" + this.myPlayer.currentTime());

      let vDuration = this.myPlayer?.duration() ?? this.props.videoDuration;
      var completedRatio = this.lastPlayTime / vDuration; 
      // console.log("Video Play Ended, Last Play Time :"+ this.lastPlayTime);
      // console.log("Video Play Ended, Player Duration :"+ vDuration);
      // console.log("Video Play Ended, Completed Ratio :"+ completedRatio);

      // Allow trigger completed only if ratio greater than 95%
      // Prevent direct drag to end
      if (completedRatio > 0.95){ 
        this.props.completed();
      }
    });

    this.myPlayer.addEventListener(amp.eventName.durationchange, (evt: any) => {
      //console.log("Video Duration " + this.myPlayer?.duration());
    });
  }


  getPlugins = () => {
    let plugins: any = {};

    
    //diagnoverlay
    plugins.PopUpImages = {
      title: "",               //overlay title
      x: "50%",                            //overlay position 
      y: "50%",
      opacity: 1,                        //overlay background opacity
      bgColor: "White",                    //overlay background color
    }

    plugins.AnswerImagesOverlay = {
      title: "",               //overlay title
      x: "50%",                            //overlay position 
      y: "50%",
      opacity: 1,                        //overlay background opacity
      bgColor: "White",                    //overlay background color
    }

    plugins.PopupContinueWatch = {
      title: "",               //overlay title
      x: "50%",                            //overlay position 
      y: "50%",
      opacity: 1,                        //overlay background opacity
      bgColor: "White",                    //overlay background color
    }

    return plugins;
  }

  showConcentrationAnswerDialog() {
    if (this.myPlayer !== undefined) {
      let answerImagesOverlayTimer: any;
        if (this.concentrationQuestionAnswerEventRegistered === false) {
          this.myPlayer.AnswerImagesOverlay.container.addEventListener("selectedImage", (evt: any) => {
            // Remove feature if answer image selected, question won't pop
            // console.log("==> Image is Selected " + evt.detail.selectedImageUrl);
            // if (this.myPlayer === undefined)
            //   return;

            // this.myPlayer.AnswerImagesOverlay.hideImage();
            // clearInterval(answerImagesOverlayTimer);
            // this.props.selectedImage(evt.detail.selectedImageUrl);
          });
          this.concentrationQuestionAnswerEventRegistered = true;
        }

      if (this.props.showConcentrationAnswer !== "") {
        this.myPlayer.AnswerImagesOverlay.loadImage(this.props.showConcentrationAnswer);
        this.myPlayer.AnswerImagesOverlay.showImage();
      } else
        this.myPlayer.AnswerImagesOverlay.hideImage();

      answerImagesOverlayTimer = setInterval(() => {
        if (this.myPlayer === undefined)
          return;

        this.myPlayer.AnswerImagesOverlay.hideImage();
        clearInterval(answerImagesOverlayTimer);
      }, 3000);
    }

  }
  popupImage(option: any) {
    if (this.myPlayer !== undefined) {
      if (this.selectedImageEventRegistered === false) {
        this.myPlayer.overlay.container.addEventListener("selectedImage", (evt: any) => {
          //console.log("==> Image is Selected " + evt.detail.selectedImageUrl);
          this.props.selectedImage(evt.detail.selectedImageUrl);
          // if (this.props.allowToPlay === true) {
          //   this.props.selectedImage(evt.detail.selectedImageUrl);
          // }else{
          //   alert('Please focus on camera to verify identity first');;
          //   return;
          // }
        });
        this.selectedImageEventRegistered = true;
      }
      if (option.show) {
        //this.myPlayer.overlay.loadImage(option.image);
        this.myPlayer.PopupContinueWatch.hideImage();
        this.myPlayer.overlay.showImage();
      }
      else
        this.myPlayer.overlay.hideImage();
    }
  }

  async componentDidMount() {
    await this.initPlayer();
    this.maxPlayTime = Number(this.props.startFrom);
  }

  componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<IState>) {
    //  console.log(prevProps);
    //  console.log(this.props);

    if (this.popupContinueSelectedImageEventRegistered === false) {
      if (this.myPlayer !== undefined) {
        this.myPlayer.PopupContinueWatch.container.addEventListener("selectedImage", (evt: any) => {
        //this.myPlayer.PopupContinueWatch.container.addEventListener("buttonClicked", (evt: any) => {
          //console.log("==> Image is Selected " + evt.detail.selectedImageUrl);
          // Remove feature if answer image selected, question won't pop
          // console.log("==> Image is Selected " + evt.detail.selectedImageUrl);
          // if (this.myPlayer === undefined)
          //   return;

          this.myPlayer.PopupContinueWatch.hideImage();
          
          this.myPlayer.play();

          // clearInterval(answerImagesOverlayTimer);
          // this.props.selectedImage(evt.detail.selectedImageUrl);
        });
        this.popupContinueSelectedImageEventRegistered = true;
      }
    }

    if (prevProps.showConcentrationAnswer !== this.props.showConcentrationAnswer) {
      //console.log("showConcentrationAnswerDialog");
      this.showConcentrationAnswerDialog()
    }

    if (prevProps.popupImage.loadImage !== this.props.popupImage.loadImage) {
      this.loadImage();
    }

    if (prevProps.popupImage.show !== this.props.popupImage.show) {
      this.popupImage(this.props.popupImage);
    }

    if (prevProps.start !== this.props.start) {

      if (this.props.start === true) {
        if (this.props.allowToPlay === true) {
          //this.myPlayer?.currentTime(this.props.startFrom);
          //this.lastPlayTime= this.props.startFrom;
          //this.maxPlayTime = this.props.startFrom;
        }
        this.play();
      } else {
        this.pause();
      }
    }
    if (prevProps.rewind !== this.props.rewind) {
      if (this.props.rewind.isRewind === true) {
        console.log("!!!!!!!! Reset rewind duration to " + this.props.rewind.duration);
        this.myPlayer?.currentTime(this.props.rewind.duration);
        this.lastPlayTime = this.props.rewind.duration;
      }
    }
  }
  loadImage() {
    if (this.myPlayer === undefined)
      return;

    this.myPlayer.overlay.loadImage(this.props.popupImage.image);
  }
  play() {
    if (this.myPlayer === undefined)
      return;

    this.myPlayer.play();
    //this.props.played();
  }

  pause() {
    if (this.myPlayer === undefined)
      return;

    if (this.myPlayer !== undefined) {
      this.myPlayer.pause();

      if (this.maxPlayTime > this.myPlayer.currentTime()) {
        //  this.props.playerCurrentTime(this.maxPlayTime); // Record Max Play Time
      } else {
        //  this.props.playerCurrentTime(this.myPlayer.currentTime()); // Updated last play time
      }

    }
  }

  render() {
    return (
      <div>
        <video
          ref={(input) => { this.videoRef = input; }}
          className="azuremediaplayer amp-default-skin"
          controls={true}
          width="100%"
          height="600"
          data-setup='{"nativeControlsForTouch": false}'
        />
      </div>
    );
  }
}